var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { alias, disgardOldValue, object } from '../../utils/serializr/serializr';
import { Question } from '../../classes/question/Question';
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { primitive } from '../../utils/serializr/schema/inner/primitive';
import { withInit } from '../../utils/serializr/schema/middle/withInit';
import { OrderedChoiceScore } from './modules/OrderedChoiceScore';
import { OrderedChoiceAnsweringFeedback } from './modules/OrderedChoiceAnsweringFeedback';
import { OrderedChoiceStore } from './modules/OrderedChoiceStore';
import { OrderedChoiceInfo } from './modules/OrderedChoiceInfo';
import { strip } from '../../utils/serializr/schema/inner/strip';
import { editable } from '../../utils/mobx/decorators/editable';
export class QuestionOrderedChoice extends Question {
    questionType = QuestionTypeName.OrderedChoice;
    get exportingChildren() {
        return [...super.exportingChildren, ...this.orderedTask.options, ...this.orderedTask.steps];
    }
    get questionScore() {
        return new OrderedChoiceScore(this);
    }
    get answeringFeedback() {
        return new OrderedChoiceAnsweringFeedback(this);
    }
    orderedChoiceStore;
    get orderedChoiceInfo() {
        return new OrderedChoiceInfo(this);
    }
    // readonly orderedChoiceKeyboard = new MultipleChoiceKeyboard(this);
    get orderedTask() {
        return this.orderedChoiceStore.task;
    }
    get task() {
        return this.orderedTask;
    }
    static get serializeInfo() {
        return {
            extends: Question.serializeInfo,
            props: {
                questionType: withInit(primitive, QuestionTypeName.OrderedChoice),
                orderedChoiceStore: alias('questionTypeStore', withInit(object(OrderedChoiceStore), {})),
                textBasis: alias('text', disgardOldValue(primitive)),
            },
        };
    }
    static get stripInfo() {
        return {
            extends: Question.stripInfo,
            props: {
                task: strip((q) => q.orderedTask.stripped),
            },
        };
    }
}
__decorate([
    editable()
], QuestionOrderedChoice.prototype, "questionType", void 0);
__decorate([
    memoize
], QuestionOrderedChoice.prototype, "questionScore", null);
__decorate([
    memoize
], QuestionOrderedChoice.prototype, "answeringFeedback", null);
__decorate([
    memoize
], QuestionOrderedChoice.prototype, "orderedChoiceInfo", null);
__decorate([
    memoize
], QuestionOrderedChoice, "serializeInfo", null);
__decorate([
    memoize
], QuestionOrderedChoice, "stripInfo", null);
